import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import { store } from '../../../common/stores/store';
import { LocalStorage_keys, Public_Routes } from '../../../constants';
import { ssoRequests } from './ssoAgent';
import { manageTokenService } from '../../../utils/manageTokenService';
import { handlingError } from './APIErrorHandler';

const requestWithTokenInterceptor = (config: AxiosRequestConfig) => {
    const token = store.commonStore.token;
    const locale = localStorage.getItem('lang');

    if (token) config!.headers!.Authorization = `Bearer ${token}`;
    if (locale) config!.headers!.Locale = locale;

    return config;
};

axios.interceptors.request.use(requestWithTokenInterceptor);

axios.interceptors.response.use(
    (response) => {
        const isTokenSoonToExpire = manageTokenService.isTokenAboutToExpire(
            localStorage.getItem(LocalStorage_keys.JWT_KEY)
        );

        if (isTokenSoonToExpire) {
            ssoRequests.getMe().then((response) => {
                localStorage.setItem(
                    LocalStorage_keys.JWT_KEY,
                    JSON.stringify(response.token)
                );
                localStorage.setItem(
                    LocalStorage_keys.USER_KEY,
                    JSON.stringify(response.user)
                );
            });
        }
        return response;
    },
    (error) => {
        const existToken = localStorage.getItem(LocalStorage_keys.JWT_KEY);

        if (error?.response?.status === 401 && existToken !== null) {
            toast.error(
                'Su sesión ha expirado, será redirigido al inicio de sesión.',
                {
                    autoClose: 4000,
                    position: toast.POSITION.TOP_CENTER,
                }
            );

            setTimeout(function () {
                window.document.location = Public_Routes.LOGIN;
            }, 4100);

            localStorage.removeItem(LocalStorage_keys.JWT_KEY);
        }
        return Promise.reject(error);
    }
);

const responseBody = (response: AxiosResponse) => response.data;

export const requests = {
    post: (url: string, body: {}): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios
            .post(url, body)
            .then(responseBody)
            .catch((error) => handlingError(error));
    },
    postFormData: (url: string, body: FormData): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;

        return axios.post(url, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    postWithParameters: (url: string, body: {}, parameters: {}): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios.post(url, body, parameters).then(responseBody);
    },
    put: (url: string, body: {}): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios.put(url, body).then(responseBody);
    },
    delete: (url: string): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;

        return axios.delete(url).then(responseBody);
    },
    deleteWithBody: (url: string, body: {}): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios
            .delete(url, {
                data: body,
            })
            .then(responseBody);
    },
    get: (url: string): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;
        return axios.get(url).then(responseBody);
    },

    post_Dublin: (url: string, body: {}): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_DUBLI_API_URL;
        return axios.post(url, body).then(responseBody);
    },
    put_Dublin: (url: string, body: {}): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_DUBLI_API_URL;
        return axios.put(url, body).then(responseBody);
    },
    get_Dublin: (url: string): Promise<any> => {
        axios.defaults.baseURL = process.env.REACT_APP_DUBLI_API_URL;
        return axios.get(url).then(responseBody);
    },
};
